import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import "./assets/main.scss";
import { defineCustomElements } from "@ionic/core/loader";
import VueApexCharts from "vue3-apexcharts";

// Inicializar Ionic Icons
defineCustomElements(window);
const app = createApp(App);

app.use(VueApexCharts);
// app.component("apexchart", VueApexCharts);
app.use(createPinia());
app.use(router);
app.mount("#app");
